var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/card.93b6671a.png","uri@2x": __webpack_public_path__ + "static/media/card.5b3bc048.png","uri@3x": __webpack_public_path__ + "static/media/card.07e0f5fc.png",
    width: 32,
    height: 26
});